// @ts-nocheck
// Persistent corner promo card. NOT a modal — no overlay, no scroll
// lock, no focus trap.
//
// Two storage layers, doing different jobs:
//   * localStorage 'promo-card:snooze:<key>' — user actively dismissed,
//     hide for N minutes (persists across tabs/sessions).
//   * sessionStorage 'promo-card:shown:<key>' — card already appeared
//     once this tab session, skip the trigger delay and the entry
//     animation on subsequent page loads in the same tab.
//
// Server-side gates already handle "campaign outside its schedule" and
// "no mode set", so we only see real cards here.

(function () {
  if (window.__promoCardLoaded) return;
  window.__promoCardLoaded = true;

  const SNOOZE_PREFIX = "promo-card:snooze:";
  const SHOWN_PREFIX = "promo-card:shown:";

  function init(card) {
    if (!card || card.dataset.promoCardBound === "1") return;
    card.dataset.promoCardBound = "1";

    const campaignKey = card.dataset.campaignKey || "default";
    const triggerDelay = parseInt(card.dataset.triggerDelay || "0", 10);
    const snoozeMinutes = Math.max(
      1,
      parseInt(card.dataset.snoozeMinutes || "60", 10),
    );
    const countdownEnabled = card.dataset.countdownEnabled === "true";
    const endTimestamp = parseInt(card.dataset.endTimestamp || "0", 10);
    const designMode =
      typeof window.Shopify !== "undefined" &&
      window.Shopify &&
      window.Shopify.designMode === true;

    const snoozeKey = SNOOZE_PREFIX + campaignKey;
    const shownKey = SHOWN_PREFIX + campaignKey;

    let countdownInterval = null;

    const valueEls = {
      hours: card.querySelector('[data-promo-countdown="hours"]'),
      minutes: card.querySelector('[data-promo-countdown="minutes"]'),
      seconds: card.querySelector('[data-promo-countdown="seconds"]'),
    };

    function pad(n) {
      return n < 10 ? "0" + n : String(n);
    }

    function tickCountdown() {
      if (!countdownEnabled || !endTimestamp) return;
      const remaining = endTimestamp - Date.now();
      if (remaining <= 0) {
        hide({ writeSnooze: false });
        return;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (valueEls.hours) valueEls.hours.textContent = pad(hours);
      if (valueEls.minutes) valueEls.minutes.textContent = pad(minutes);
      if (valueEls.seconds) valueEls.seconds.textContent = pad(seconds);
    }

    function startCountdown() {
      if (!countdownEnabled || !endTimestamp) return;
      tickCountdown();
      countdownInterval = window.setInterval(tickCountdown, 1000);
    }

    function show(opts) {
      const animate = opts && opts.animate;
      if (animate) card.classList.add("is-animating-in");
      card.classList.add("is-visible");
      if (animate) {
        // Strip the animation class after it ends so re-shows don't restart it.
        const onEnd = () => {
          card.classList.remove("is-animating-in");
          card.removeEventListener("animationend", onEnd);
        };
        card.addEventListener("animationend", onEnd);
      }
      startCountdown();
    }

    function hide(opts) {
      const writeSnooze = opts && opts.writeSnooze;
      card.classList.remove("is-visible");
      card.classList.remove("is-animating-in");
      if (countdownInterval) {
        window.clearInterval(countdownInterval);
        countdownInterval = null;
      }
      if (writeSnooze) {
        try {
          localStorage.setItem(
            snoozeKey,
            String(Date.now() + snoozeMinutes * 60000),
          );
        } catch (e) {
          /* storage may be unavailable in some browsers/incognito */
        }
        // Clear the per-session shown flag so when snooze expires later
        // in the same tab, the next page load treats the card as a fresh
        // first appearance (delay + animation).
        try {
          sessionStorage.removeItem(shownKey);
        } catch (e) {
          /* noop */
        }
      }
    }

    // Close button + ESC handler
    const closeBtn = card.querySelector("[data-promo-close]");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => hide({ writeSnooze: true }));
    }
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (!card.classList.contains("is-visible")) return;
      hide({ writeSnooze: true });
    });

    // Visibility decision
    if (designMode) {
      // Theme editor: always render visible, skip storage + delay so the
      // merchant can see their config immediately.
      show({ animate: false });
      return;
    }

    let snoozeUntil = 0;
    try {
      snoozeUntil = parseInt(localStorage.getItem(snoozeKey) || "0", 10) || 0;
    } catch (e) {
      /* noop */
    }
    if (snoozeUntil && snoozeUntil > Date.now()) {
      return;
    }

    // Past snooze: also expired, clear it so we don't keep parsing it forever.
    if (snoozeUntil && snoozeUntil <= Date.now()) {
      try {
        localStorage.removeItem(snoozeKey);
      } catch (e) {
        /* noop */
      }
    }

    let alreadyShown = false;
    try {
      alreadyShown = sessionStorage.getItem(shownKey) === "1";
    } catch (e) {
      /* noop */
    }

    if (alreadyShown) {
      // Subsequent page load in same tab: show immediately, no delay,
      // no entry animation.
      show({ animate: false });
      return;
    }

    // First appearance this session.
    window.setTimeout(() => {
      // Final check — bail out cleanly if the card was removed from the
      // DOM during the delay (rare, but defensive).
      if (!card.isConnected) return;
      show({ animate: true });
      try {
        sessionStorage.setItem(shownKey, "1");
      } catch (e) {
        /* noop */
      }
    }, Math.max(0, triggerDelay) * 1000);
  }

  function bootstrap() {
    const cards = document.querySelectorAll("[data-promo-card]");
    for (let i = 0; i < cards.length; i++) init(cards[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
  } else {
    bootstrap();
  }
})();
